import React from 'react';

import { Card, Flex } from 'antd-v5';
import { MdAssignmentLate } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

export function BaseMessage(props: {
  title: React.ReactNode;
  content?: React.ReactNode;
}) {
  return (
    <Card>
      <Flex gap={8} justify="center" vertical align="center">
        <MdAssignmentLate
          color={cssVars['color-text-regular']}
          style={{ fontSize: 40 }}
        />
        <Text font="body-body-2" strong>
          {props.title}
        </Text>
        <Text font="body-body-3">{props.content}</Text>
      </Flex>
    </Card>
  );
}

export function EmptyState() {
  return (
    <BaseMessage
      title={<FormattedMessage id="page.mbcBulkAssign.emptySelection.title" />}
      content={<FormattedMessage id="page.mbcBulkAssign.emptySelection.body" />}
    />
  );
}

export function NoCorrectUnit() {
  return (
    <BaseMessage
      title={<FormattedMessage id="page.mbcBulkAssign.noValidUnit.title" />}
      content={<FormattedMessage id="page.mbcBulkAssign.noValidUnit.body" />}
    />
  );
}

export function NoAvailableYouth() {
  return (
    <BaseMessage
      title={<FormattedMessage id="page.mbcBulkAssign.noYouth.title" />}
      content={<FormattedMessage id="page.mbcBulkAssign.noYouth.body" />}
    />
  );
}
